import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminSEOPages = lazy(() => import("@/pages/admin/AdminSEOPages"));

export const Route = createFileRoute("/admin/seo-pages")({
  component: AdminSEOPages,
});
